import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject } from "../shared";
export function calculateFlatTopBottomGeometry(drawing, scales) {
    const [p0] = drawing.points;
    if (!p0)
        return null;
    const pixel = chartPointToPixel(p0, scales);
    // Horizontal line spans full viewport width - use a large value for xEnd
    // The actual rendering will clip to viewport
    return {
        y: pixel.y,
        xStart: -10000,
        xEnd: 10000,
    };
}
const FlatTopBottom = {
    name: "flatTopBottom",
    createDraft: (startPoint) => createDrawingObject("flatTopBottom", [startPoint]),
    updateDraft: (draft, nextPoint) => ({
        ...draft,
        points: [{ ...draft.points[0], y: nextPoint.y }], // Only update Y (price level)
    }),
    render: () => undefined,
};
export default FlatTopBottom;
